import yup from '../../../config/yup';

export const graphqlReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('graphqlReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    acceptInvalidCerts: yup.boolean(),
    url: yup.string(),
    headerJson: yup.string(),
    body: yup.string(),
    debug: yup.boolean(),
  }),
});
